
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/2026-MUI-X-price-changes",
      function () {
        return require("private-next-pages/blog/2026-MUI-X-price-changes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/2026-MUI-X-price-changes"])
      });
    }
  